import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MustMatch} from '../../../../_helpers/match';
import {UserService} from '../../../../_services';
import {ToastService} from '../../../../_services/toast.service';
import {TranslateService} from '@ngx-translate/core';
import {LoadingService} from '../../../../_services/loading.service';
import {ActivatedRoute, Router} from '@angular/router';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  submitted = false;
  email: string;
  showPassword = false;
  showConfirmPassword = false;

  constructor(private authentication: UserService,
              public toast: ToastService,
              private route: ActivatedRoute,
              public translate: TranslateService,
              private spinner: LoadingService,
              public authService: UserService,
              public router: Router) {
    this.resetPasswordForm = new FormGroup({
      /*email: new FormControl('',
        [
          Validators.required,
          Validators.email
        ]),*/
      token: new FormControl('',
        [
          Validators.required
        ]),
      password: new FormControl('',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern('^(?=.*\\d)(?=.*[a-z])[\\w~@#$%^&*+=`|{}:;!.?\\"()\\[\\]-]{6,18}$')
        ]),
      confirmPassword: new FormControl('',
        [Validators.required])
    }, {
      validators: MustMatch('password', 'confirmPassword')
    });

    this.route.queryParams.subscribe(params => {
      // Defaults to 0 if no query param provided.
      this.email = params.email || '';
      // this.resetPasswordForm.get('email').patchValue(this.email);
    });

  }

  ngOnInit() {
  }

  // convenience getter for easy access to form fields
  get field(): any {
    return this.resetPasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.resetPasswordForm.invalid) {
      return;
    }
    const user = {
      email: this.email,
      password: this.resetPasswordForm.value.password,
      token: this.resetPasswordForm.value.token
    };
    this.spinner.show();
    this.authService.resetPassword(user)
      .pipe(first())
      .subscribe(
        (userObj) => {
          this.spinner.hide();
          this.toast.display('Password updated successfully');
          this.router.navigate(['./project/ic']);
        },
        (error) => {
          this.spinner.hide();
          console.error(error);
          this.toast.error('Couldn\'t update password, Please contact admin');
        });
  }

  togglePassword(event: boolean) {
    this.showPassword = event;
  }

  toggleConfirmPassword(event: boolean) {
    this.showConfirmPassword = event;
  }
}
